import { Grid, Table, TableBody, TableCell, TableRow } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";

import { Amount } from "../../../../components/amount";
import { DetailTable } from "../../../../components/detail_table";
import { IAsyncData } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { SingleClientHistoryFilter } from "../../../client_history/ui/components/single_client_history_filter";
import { SingleClientHistoryList } from "../../../client_history/ui/components/single_client_history_list";
import { IClient } from "../../data/entities";
import { clientRedux } from "../state/state";

export const ClientDetailPage: React.FC = () => {
  const match = useRouteMatch<{ id: string }>();
  const { id } = match.params;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clientRedux.actions.getDetail(id));
  }, [dispatch, id]);
  const clientDetailBranch = useSelector<IAppReduxState, IAsyncData<IClient>>((state) => state.client.details);

  return (
    <Grid container justify="center">
      <Grid item xs={12} sm={12} lg={10}>
        <DetailTable branch={clientDetailBranch} route={ROUTES.client}>
          <Table size="medium" className="detail-table">
            <TableBody>
              <TableRow>
                <TableCell>Ad</TableCell>
                <TableCell>{clientDetailBranch.data?.name}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Balans</TableCell>
                <TableCell>
                  <Amount amount={clientDetailBranch.data?.balance} />
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Maaş</TableCell>
                <TableCell>{clientDetailBranch.data?.salary} AZN</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Məlumat</TableCell>
                <TableCell>{clientDetailBranch.data?.info}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Tipi</TableCell>
                <TableCell>{clientDetailBranch.data?.type}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </DetailTable>

        <SingleClientHistoryFilter clientId={id} />

        <SingleClientHistoryList clientId={id} />
      </Grid>
    </Grid>
  );
};
